import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavExpensesInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#Sidenav-Expenses-Inactive_svg__a)">
      <path
        fill={props.fill || text_colorTextSecondary}
        fillRule="evenodd"
        d="M2.417 10a7.583 7.583 0 1 1 15.166 0 7.583 7.583 0 0 1-15.166 0ZM10 .917a9.083 9.083 0 1 0 0 18.166A9.083 9.083 0 0 0 10 .917Zm-.533 4.132a.438.438 0 0 1 .338-.143h.412c.122 0 .236.044.322.137a.426.426 0 0 1 .136.32v.58c.431.07.806.205 1.12.407.348.224.619.488.805.795.18.299.282.602.29.906v.005a.468.468 0 0 1-.093.274l-.004.006-.005.006a.42.42 0 0 1-.334.14h-.576a.573.573 0 0 1-.256-.065l-.01-.006a.498.498 0 0 1-.212-.272l-.007-.02-.003-.021c-.034-.23-.161-.433-.413-.61-.245-.17-.576-.265-1.01-.265-.444 0-.787.085-1.041.24-.22.138-.335.348-.335.67 0 .203.055.36.157.484.108.124.292.25.572.365.286.12.665.247 1.138.383a8.48 8.48 0 0 1 1.456.523c.393.185.698.428.897.734.21.304.307.685.307 1.126 0 .442-.11.84-.337 1.188-.219.34-.532.606-.93.801-.341.17-.735.282-1.176.337v.562a.426.426 0 0 1-.136.321.426.426 0 0 1-.322.137h-.412a.438.438 0 0 1-.338-.143.444.444 0 0 1-.12-.315v-.572c-.47-.056-.88-.175-1.227-.363l-.002-.001c-.385-.216-.687-.479-.897-.794a1.952 1.952 0 0 1-.339-1.007v-.01c0-.117.046-.22.126-.3a.447.447 0 0 1 .321-.136h.565c.118 0 .239.033.332.126a.53.53 0 0 1 .141.249c.035.138.109.285.232.44.112.135.277.258.507.364.227.094.529.145.916.145.606 0 1.007-.107 1.242-.283a.854.854 0 0 0 .363-.724c0-.206-.063-.35-.175-.458l-.007-.006c-.122-.128-.326-.256-.63-.373a14.7 14.7 0 0 0-1.22-.396 7.39 7.39 0 0 1-1.352-.515c-.373-.194-.663-.44-.86-.745l-.003-.003c-.192-.31-.28-.69-.28-1.13 0-.587.219-1.093.649-1.507.397-.39.936-.621 1.598-.71v-.563c0-.115.035-.227.12-.315Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Sidenav-Expenses-Inactive_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgSidenavExpensesInactive
